import { z } from 'zod';

export const ReportSchema = z.object({
  id: z.string().or(z.number()),
  mmsi: z.string().or(z.number()),
  status: z.enum(['complete', 'in progress', 'failed']),
  created_timestamp: z.string(),
  vessel_name: z.string().optional().nullable(),
  s3_url: z.string().optional().nullable(),
});

export type Report = z.infer<typeof ReportSchema>;

export const ReportsResponseSchema = z.object({
  reports: z.array(ReportSchema),
});
